/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/11/19
 * Time: 10:19 AM
 */
import * as actionTypes from '../actionTypes'

export const systemChangeHandler = (data) => {
  return {
    type: actionTypes.SYSTEM_CHANGER,
    value: data
  }
};
